// John Eldhose 20180618
import { RestfulPost } from './Restful';

export async function updateAccount(data, orgi) {
  data['original'] = orgi;
  const acc = await RestfulPost('updateAccount', {data: data}, (response) => {
      return response['data'];
    }, (error) => {
      console.log(error);
      return false;
    }
  );
  return acc;
}



// WEBPACK FOOTER //
// ./src/Api/updateAccount.js